import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import * as styles from 'src/components/organisms/Header/style.module.styl'

import Img from 'src/components/molecules/common/ResponsiveImage'

const Component:React.FC = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            corporateName
          }
        }
      }
    `
  )

  return (
    <header className={styles.header}>
      <div className={styles.header_inner}>
        <h1 className={styles.header_logo}>
          <a href="https://tire.bridgestone.co.jp/" target="_blank" rel="noreferrer noopener"><Img src="common/header/ci_logo_1.svg" alt={ site?.siteMetadata.corporateName } /></a>
        </h1>
      </div>
    </header>
  )
}

export default Component
